<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon left color="primary">mdi-whatsapp</v-icon>
        Clientes Siczap
      </v-card-title>

      <v-card-text>
        <!-- Linha de busca + botão download -->
        <v-row class="mb-4">
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pesquisar pelo Nome, Nome Fantasia ou CNPJ"
              single-line
              hide-details
            />
          </v-col>
          <v-spacer />
          <v-col>
            <downloadexcel
              class="v-btn v-btn--contained theme--light v-size--default primary mt-3"
              :data="JSON.parse(JSON.stringify(clientes))"
              :fields="fieldsExcel"
              worksheet="relatorio"
              name="relatorio-clientes-siczap.xls"
            >
              DOWNLOAD EXCEL
            </downloadexcel>
          </v-col>
        </v-row>

        <!-- Divider para separar visualmente a busca da tabela -->
        <v-divider class="my-4" />

        <!-- Tabela de clientes -->
        <v-data-table
          :headers="headers"
          :items="clientes"
          class="elevation-1"
          :loading="loading"
          dense
        />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import downloadexcel from 'vue-json-excel'
import { mapGetters } from 'vuex'

export default {
    components: {
        downloadexcel
    },
    data: function () {
        return {
            clientes: [],
            headers: [
                { text: 'N.Fantasia', value: 'nome_fantasia', sortable: false },
                { text: 'N.Razão', value: 'nome', sortable: false },
                { text: 'CNPJ', value: 'cnpj', sortable: false },
                { text: 'Total de Instâncias', value: 'total_instancias', sortable: false },
            ],
            fieldsExcel: {
                NOMERAZAO: 'nome',
                NOMEFANTASIA: 'nome_fantasia',
                CNPJ: 'cnpj',
                QTD_INSTÂNCIA: 'total_instancias'
            },
            search: '',
            loading: false,
            clienteId: '',
        }
    },
    computed: {
        ...mapGetters(['userAdmin', 'userMaster']),
    },
    methods: {
        async loadClientes() {
            try {
                this.loading = true
                const response = await this.axios.get('/clientes/siczap', {
                    params :{
                        search: this.search,
                    }
                })
                this.clientes = response.data.clientes
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false
            }
        },
        loadClientesSearch() {
            this.loadClientes()
        },
    },
    mounted() {
        this.loadClientes()
    },
    watch: {
        options: {
            handler() {
                this.loadClientes()
            },
            deep: true,
        },
        search() {
            this.loadClientesSearch()
        },
    },
}
</script>
